var exports = {
  "h_": "DuplicateGroupConfirmModal.module__description___SXFoc1",
  "o5": "DuplicateGroupConfirmModal.module__channelList___SXFoc1",
  "fc": "DuplicateGroupConfirmModal.module__channelItem___SXFoc1",
  "R3": "DuplicateGroupConfirmModal.module__avatarWrapper___SXFoc1",
  "E8": "DuplicateGroupConfirmModal.module__channelDetails___SXFoc1",
  "HA": "DuplicateGroupConfirmModal.module__channelName___SXFoc1",
  "Rj": "DuplicateGroupConfirmModal.module__lastActive___SXFoc1",
};

module.exports = exports;
